"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    staticClass: "equipment-page",
    attrs: {
      menu: _vm.menuItems.children,
      "sub-menu": _vm.menuItems.subMenu,
      "return-menu": "/farm-management/dashboard"
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("h2", {
    staticClass: "header-title"
  }, [_vm._v("\n        Equipamentos\n      ")]), _vm._v(" "), _c("div", {
    staticClass: "search-bar"
  }, [_c("div", {
    staticClass: "field search-input"
  }, [_c("p", {
    staticClass: "filter-label"
  }, [_vm._v("\n            Filtrar por período\n          ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("b-field", [_c("b-datepicker", {
    attrs: {
      placeholder: "Data inicial",
      icon: "calendar",
      "max-date": _vm.dateEnd,
      "mobile-native": false
    },
    on: {
      input: _vm.loadAsyncDataList
    },
    model: {
      value: _vm.dateStart,
      callback: function callback($$v) {
        _vm.dateStart = $$v;
      },
      expression: "dateStart"
    }
  })], 1), _vm._v(" "), _c("b-field", [_c("b-datepicker", {
    attrs: {
      placeholder: "Data final",
      icon: "calendar",
      "min-date": _vm.dateStart,
      "mobile-native": false
    },
    on: {
      input: _vm.loadAsyncDataList
    },
    model: {
      value: _vm.dateEnd,
      callback: function callback($$v) {
        _vm.dateEnd = $$v;
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "field-new-item"
  }, [_c("b-button", {
    on: {
      click: function click($event) {
        return _vm.openEquipmentModal();
      }
    }
  }, [_vm._v("\n            Novo equipamento\n          ")])], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "table-items-list"
  }, [_c("b-table", {
    attrs: {
      data: _vm.list,
      loading: _vm.isLoading,
      paginated: "",
      total: _vm.total,
      "per-page": _vm.perPage,
      striped: true,
      hoverable: true,
      "backend-pagination": ""
    },
    on: {
      "page-change": _vm.onPageChange
    }
  }, [[_c("b-table-column", {
    attrs: {
      field: "nome",
      label: "Nome"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.nome) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "fabricante",
      label: "Fabricante"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.fabricante) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "tipo",
      label: "Tipo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.tipo) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "observacao",
      label: "Observação",
      width: "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [props.row.observacao ? _c("span", {
          staticClass: "text-cell",
          attrs: {
            title: props.row.observacao
          }
        }, [_vm._v("\n              " + _vm._s(_vm.truncateText(props.row.observacao, 40)) + "\n            ")]) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      width: "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            "aria-role": "list",
            label: "Editar",
            position: "is-top-left"
          }
        }, [_c("b-button", {
          staticClass: "btn-click-dots",
          attrs: {
            slot: "trigger",
            outlined: "",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          attrs: {
            "aria-role": "listitem"
          },
          on: {
            click: function click($event) {
              return _vm.openEquipmentModal(props.row);
            }
          }
        }, [_c("b-icon", {
          attrs: {
            icon: "pencil",
            size: "is-small"
          }
        }), _vm._v("\n                Editar\n              ")], 1), _vm._v(" "), _c("b-dropdown-item", {
          attrs: {
            "aria-role": "listitem"
          },
          on: {
            click: function click($event) {
              return _vm.verifyDelete(props.row);
            }
          }
        }, [_c("b-icon", {
          attrs: {
            icon: "delete",
            size: "is-small"
          }
        }), _vm._v("\n                Excluir\n              ")], 1)], 1)];
      }
    }])
  })], _vm._v(" "), _c("template", {
    slot: "empty"
  }, [_c("section", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c("p", [_c("b-icon", {
    attrs: {
      icon: "emoticon-sad",
      size: "is-large"
    }
  })], 1), _vm._v(" "), _c("p", [_vm._v("Nenhum equipamento encontrado.")])])])])], 2)], 1)])], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;